export const convertNumberToLocaleString = number => number?.toLocaleString();
export const convertLocaleStringToNumber = str =>
  parseInt(str.replaceAll(',', ''));
export const removeEmoji = str => {
  const regex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
  return str.replace(regex, '');
};
export const formatUrl = source => {
  let url_full = source.replace(/\/$/, '').replace('?hl=en', '');
  let url_path = url_full.substring(url_full.lastIndexOf('/') + 1);
  return url_path;
};

export const capitalize = s => {
  return s[0].toUpperCase() + s.slice(1);
};

export const truncate = (fullStr, strLen, separator) => {
  if (fullStr.length <= strLen) return fullStr;

  separator = separator || '...';

  const sepLen = separator.length,
    charsToShow = strLen - sepLen,
    frontChars = Math.ceil(charsToShow / 2),
    backChars = Math.floor(charsToShow / 2);

  return (
    fullStr.substr(0, frontChars) +
    separator +
    fullStr.substr(fullStr.length - backChars)
  );
};
